import React from "react";
import { Odd } from "../../../../models/Odd_response_model.tsx";
import { useBetContext } from "../../../../context/BetContext.tsx";
import { SelectedOddCommercialLive } from "./SelectedOddCommercialLive.tsx";
import { pickPreferredSportsbook } from "../../../../helpers/functions.tsx";

interface IBetSelectorCommercialLive {
    availableOdds: Odd[],
    onRequestBetsModal: Function,
    slotIndex: number
}

function pickMainSelections(selections: Odd[]): Odd[] {
    if (selections.length <= 1) return selections;

    const nonMains = selections.filter(o => !o.is_main);
    if (nonMains.length > 0) return nonMains;

    const preferredBook = pickPreferredSportsbook(selections);
    const preferred = selections.find(o => o.sportsbook === preferredBook);
    return preferred ? [preferred] : [selections[0]];
}

export function BetSelectorCommercialLive(props: IBetSelectorCommercialLive) {
    const { onRequestBetsModal, availableOdds, slotIndex } = props;
    const { bets } = useBetContext();
    const underSelection = availableOdds.filter(o => o.selection_line === "under");
    const overSelection = availableOdds.filter(o => o.selection_line === "over");
    // Moneyline arrives as null or undefined
    const noSelections = availableOdds.filter(o => o.selection_line == null);

    const predicate = (o: Odd) => {
        const bet = bets.find(bet => bet.id_selection === o.id);
        if (bet !== undefined) return true;
        return o.is_main !== false;
    };

    const odds = [
        pickMainSelections(overSelection.filter(o => predicate(o))),
        pickMainSelections(underSelection.filter(o => predicate(o))),
        pickMainSelections(noSelections.filter(o => predicate(o))),
    ];

    return (
        <>
            {odds.map((selections, index) =>
                selections.map((o, i) => {
                    const bet = bets.find(bet => bet.id_selection === o.id);
                    return (
                        <div className="market-container-flex" key={`${o.id}-${index}-${i}`}>
                            <SelectedOddCommercialLive
                                o={o}
                                currentBet={bet}
                                onRequestBetsModal={onRequestBetsModal}
                                slotIndex={slotIndex}
                            />
                        </div>
                    );
                })
            )}
        </>
    );
}
